import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import KenColors from '../../Helpers/Themes/kenColors';

export const useStyles = makeStyles((theme: Theme) => ({
  loginButton: {
    width: '100%',
    borderRadius: '8px !important',
    margin: '8px auto !important',
    border: `2px solid ${theme.palette.KenColors.neural500} !important`,
    background: `${theme.palette.KenColors.kenWhite} !important`,
    boxShadow: `0px 18px 30px 0px ${theme.palette.KenColors.ClientShadow}`,
    padding: '9px 35px !important',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '&:hover': {
      background: `${theme.palette.KenColors.kenWhite} !important`,
    },
    '&:active': {
      background: `${theme.palette.KenColors.kenWhite} !important`,
    },
  },
  resend: {
    border: 'none',
    fontSize: '12px',
    fontWeight: '500 !important',
    color: '#2C58E8',
    cursor: 'pointer',
    marginTop: '20px !important',
  },
  footerSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '400px',
    marginTop: '60px',
  },
  backButton: {
    color: '#373A45',
    fontWeight: '500 !important',
    fontSize: '12px',
    cursor: 'pointer',
    textDecoration: 'underline',
    marginTop: '10px',
  },
  otpContainerCard: {
    padding: '31px 90px',
    borderRadius: '20px !important',
    marginTop: '20px',
    height: '108px',
    width: '360px',
    boxShadow: 'none !important',
  },
  backIcon: {
    height: '26px',
    width: 'auto',
    color: theme.palette.KenColors.clientBlackBackground,
  },
  otpHeader: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  formLayout: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '0px !important',
    width: '100%',
    height: '100%',
  },
  loginIcons: {
    height: '20px',
    width: '20px',
  },
  logo: {
    height: '54px',
    width: '54px',
    objectFit: 'cover',
  },
  loginText: {
    fontWeight: '600 !important',
    fontSize: '12px !important',
    color: theme.palette.KenColors.clientBlackBackground,
  },
  title: {
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: '600 !important',
    color: theme.palette.KenColors.clientBlackBackground,
    marginBottom: '20px !important',
  },
  titleOtp: {
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.clientBlackBackground,
    marginBottom: '20px !important',
  },
  titleVerified: {
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.clientBlackBackground,
    marginBottom: '20px !important',
  },
  descriptionVerified: {
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: '400 !important',
    color: theme.palette.KenColors.clientBlackBackground,
    marginBottom: '20px !important',
  },
  inputFieldLabel: {
    fontWeight: '500 !important',
    fontSize: '16px !important',
    color: theme.palette.KenColors.clientCLight,
  },
  subTitle: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: `${theme.palette.KenColors.clientError} !important`,
    fontFamily: 'GeneralSans !important',
  },
  verify: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    background: `${theme.palette.KenColors.ClientPrimary} !important`,
    textTransform: 'none',
    color: `${theme.palette.KenColors.kenWhite} !important`,
    borderRadius: '8px !important',
    height: '36px',
    width: '100%',
    padding: '9px !important',
  },
  verify1: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    background: `${theme.palette.KenColors.ClientPrimary} !important`,
    textTransform: 'none',
    color: `${theme.palette.KenColors.kenWhite} !important`,
    borderRadius: '8px !important',
    width: '90px',
    height: '36px',
    padding: '9px !important',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px !important',
  },
  inputStyles: {
    height: '36px !important',
    fontSize: '12px !important',
    borderRadius: '6px !important',
    backgroundColor: '#FFFFFF',
  },
  inputStyles1: {
    height: '36px !important',
    width: '333px !important',
    fontSize: '12px !important',
    borderRadius: '6px !important',
    backgroundColor: '#FFFFFF',
    marginLeft: '40px !important',
  },
  label: {
    fontWeight: '500 !important',
    fontSize: '12px !important',
    textAlign: 'left',
    margin: '4px 0px 5px 0px !important',
    color: theme.palette.KenColors.clientBlackBackground,
    fontFamily: 'GeneralSans !important',
  },
  label1: {
    fontWeight: '500 !important',
    fontSize: '12px !important',
    textAlign: 'left',
    margin: '4px 0px 5px 0px !important',
    color: theme.palette.KenColors.clientBlackBackground,
    fontFamily: 'GeneralSans !important',
    marginLeft: '40px !important',
  },
  formContainerLayout: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '60%',
    gap: '10px',
    height: '100%',
  },
  fieldLayout: {
    display: 'inline-block',
    alignItems: 'center',
  },
  accountLink: {
    color: theme.palette.KenColors.clientBlackBackground,
    fontSize: '14px !important',
    fontFamily: 'GeneralSans !important',
  },
  phoneInputStyles: {
    textAlign: 'start',
    borderRadius: '0px 8px 8px 0px !important',
    color: theme.palette.KenColors.ClientGrey,
    margin: '0px !important',
    padding: '12px !important',
    width: '100% !important',
    background: `${theme.palette.KenColors.kenWhite} !important`,
    border: `2px solid ${theme.palette.KenColors.grey} !important`,
    borderLeft: '0px !important',
    height: '36px !important',
  },
  confirmMailContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
  cardContainer: {
    borderRadius: '12px !important',
    width: '360px',
    marginTop: '20px',
    height: '135px',
    boxShadow: 'none !important',
  },
  countryCodeError: {
    background: theme.palette.KenColors.kenWhite,
    textAlign: 'start',
    margin: '0px',
    padding: '0px',
    borderRadius: '10px 0px 0px 10px !important',
    border: '2px solid red !important',
    color: theme.palette.KenColors.clientBlackBackground,
    '&:hover': {
      border: '2px solid red !important',
      borderRadius: '10px 0px 0px 10px !important',
    },
    '&.open': {
      background: theme.palette.KenColors.kenWhite,
      '& .selected-flag': {
        background: theme.palette.KenColors.kenWhite,
      },
    },
    '& .selected-flag': {
      '&:hover': {
        background: theme.palette.KenColors.kenWhite,
      },
    },
  },
  phoneError: {
    border: '2px solid red !important',
    borderLeft: '0px !important',
  },
  countryCode: {
    background: theme.palette.KenColors.kenWhite,
    textAlign: 'start',
    margin: '0px',
    padding: '0px',
    borderRadius: '8px 0px 0px 8px !important',
    border: `2px solid ${theme.palette.KenColors.grey} !important`,
    color: theme.palette.KenColors.clientBlackBackground,
    '&:hover': {
      border: `2px solid ${theme.palette.KenColors.grey} !important`,
      borderRadius: '7px 0px 0px 7px !important',
    },
    '&.open': {
      background: theme.palette.KenColors.kenWhite,
      '& .selected-flag': {
        background: theme.palette.KenColors.kenWhite,
      },
    },
    '& .selected-flag': {
      '&:hover': {
        background: theme.palette.KenColors.kenWhite,
      },
    },
  },
  otpCard: {
    boxShadow: 'none !important',
    borderRadius: '15px !important',
    padding: '25px',
    display: 'flex',
    justifyContent: 'center',
  },
  verifyCard: {
    boxShadow: 'none !important',
    borderRadius: '15px !important',
    padding: '25px',
  },
  otpInput: {
    width: '50px',
    height: '58px',
    border: '1px solid #A0B6FF !important',
    borderRadius: '10px !important',
    backgroundColor: '#EAEFFF',
  },
  otpInput1: {
    width: '50px',
    height: '58px',
    border: '1px solid #A0B6FF !important',
    borderRadius: '10px !important',
    backgroundColor: '#EAEFFF',
    marginLeft: '15px !important',
  },
  emailText: {
    color: '#373A45',
    textDecoration: 'underline',
    textAlign: 'center',
    marginTop: '43px !important',
    fontWeight: '500 !important',
  },
  verifyButton: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    background: `${theme.palette.KenColors.ClientPrimary} !important`,
    textTransform: 'none',
    color: `${theme.palette.KenColors.kenWhite} !important`,
    borderRadius: '8px !important',
    width: '300px !important',
    height: '45px',
    padding: '12px !important',
    marginTop: '40px !important',
  },
}));

export const otpInputStyle = {
  border: `1px solid #A0B6FF`,
  borderRadius: '6px',
  width: '36px',
  height: '48px',
  fontSize: '16px',
  margin: '0 8px',
  textAlign: 'center',
  justifyContent: 'center',
  backgroundColor: '#EAEFFF',
} as React.CSSProperties;

export const otpContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as React.CSSProperties;
